import { Link } from 'react-router-dom';
import { categories, articles, faqs } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

const featuredArticles = articles.slice(0, 6);

const heroKeywords = ['鲍鱼tv跳转', '鲍鱼tv跳转入口', '鲍鱼tv最新地址', '鲍鱼tv官网跳转', '鲍鱼tv跳转方法', '鲍鱼tv访问教程', '鲍鱼tv跳转链接'];

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '鲍鱼tv跳转导航',
            url: 'https://baoyutv-tiaozhuan.com/',
            description: '鲍鱼tv跳转最新方法、官方地址更新说明及常见问题解答，帮助用户快速完成鲍鱼tv跳转。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://baoyutv-tiaozhuan.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '鲍鱼tv跳转导航',
            url: 'https://baoyutv-tiaozhuan.com/',
            description: '专注于鲍鱼tv平台入口导航与使用教程的综合资讯平台',
          }),
        }}
      />

      <main>
        {/* Hero Section */}
        <section className="relative w-full overflow-hidden" aria-label="网站介绍">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20gold%20abstract%20geometric%20background%20with%20soft%20flowing%20curves%20and%20gradient%20textures%2C%20modern%20minimalist%20design%2C%20clean%20aesthetic%2C%20warm%20lighting%2C%20digital%20technology%20atmosphere%2C%20smooth%20glass%20morphism%20effect%2C%20elegant%20and%20professional%20style%2C%20subtle%20tech%20elements%2C%20warm%20tone%20color%20palette%20with%20teal%20accents&width=1600&height=700&seq=hero-bg-2025&orientation=landscape"
              alt="鲍鱼tv跳转导航背景"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full min-h-[420px] md:min-h-[560px] flex flex-col items-center justify-center text-center px-4 py-16 md:py-24">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 md:mb-6 leading-tight max-w-3xl">
              鲍鱼tv跳转 —— 快速入口与使用指南
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl leading-relaxed">
              找不到鲍鱼tv跳转入口？本页提供鲍鱼tv跳转最新方法、官方地址更新说明及常见问题解答，帮助用户快速完成鲍鱼tv跳转，畅享平台内容。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/tiaozhuan-fangfa"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-skip-forward-line"></i>
                查看跳转方法
              </Link>
              <Link
                to="/category/zuixin-dizhi"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-white font-semibold rounded-full border border-white/30 transition-all duration-200 backdrop-blur-sm whitespace-nowrap text-sm"
              >
                <i className="ri-link"></i>
                获取最新地址
              </Link>
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-2 max-w-2xl">
              {heroKeywords.map((kw) => (
                <span key={kw} className="px-3 py-1 bg-white/10 backdrop-blur-sm text-white/70 text-xs rounded-full whitespace-nowrap">
                  {kw}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Category Overview */}
        <section className="py-14 md:py-20 bg-background-100/70" aria-label="分类导航">
          <div className="container-site">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                内容分类导航
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                按分类浏览鲍鱼tv跳转相关教程与资讯，快速找到您需要的内容
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="group bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-accent-300/60 transition-all duration-300 flex items-start gap-4"
                >
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors duration-200">
                    <i className={`${cat.icon} text-xl text-accent-600`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-base font-semibold font-heading text-foreground-900 mb-1 group-hover:text-accent-700 transition-colors duration-200 whitespace-nowrap">
                      {cat.name}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                      {cat.description}
                    </p>
                    <span className="text-xs text-accent-600 font-medium">
                      {cat.articleCount} 篇文章
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-14 md:py-20" aria-label="精选文章">
          <div className="container-site">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
                  精选文章推荐
                </h2>
                <p className="text-sm text-foreground-500">
                  最新最热门的鲍鱼tv跳转教程与资讯
                </p>
              </div>
              <Link
                to="/category/tiaozhuan-fangfa"
                className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors duration-200 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 bg-background-100/70" aria-label="常见问题">
          <div className="container-site">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                常见问题解答
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                关于鲍鱼tv跳转的常见疑问，这里都有答案
              </p>
            </div>
            <div className="max-w-3xl mx-auto grid grid-cols-1 gap-3 md:gap-4">
              {faqs.slice(0, 4).map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.question}</span>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                      <i className="ri-arrow-down-s-line text-lg"></i>
                    </span>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/category/changjian-wenti"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-700 hover:bg-secondary-200 font-medium rounded-full transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-question-answer-line"></i>
                查看更多问题解答
              </Link>
            </div>
          </div>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqs.slice(0, 4).map((faq) => ({
                  '@type': 'Question',
                  name: faq.question,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer,
                  },
                })),
              }),
            }}
          />
        </section>

        {/* CTA Section */}
        <section className="py-14 md:py-20" aria-label="行动号召">
          <div className="container-site">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20lines%20and%20glowing%20amber%20and%20teal%20accents%2C%20modern%20clean%20design%2C%20minimalist%20tech%20aesthetic%2C%20smooth%20gradient%20texture%2C%20professional%20atmosphere%2C%20digital%20connection%20concept%2C%20warm%20elegant%20tone&width=1200&height=400&seq=cta-bg-2025&orientation=landscape"
                alt="收藏本站"
                className="w-full h-full object-cover object-top absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 to-foreground-900/40"></div>
              <div className="relative z-10 text-center py-12 md:py-16 px-6">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mb-3">
                  收藏本站，随时随地找到鲍鱼tv入口
                </h2>
                <p className="text-white/75 text-sm md:text-base mb-6 max-w-lg mx-auto">
                  将本页加入浏览器收藏夹，或添加到手机桌面，确保随时获取最新鲍鱼tv跳转入口与使用指南
                </p>
                <div className="flex flex-wrap justify-center gap-2 text-white/60 text-xs">
                  <span className="px-2 py-1 bg-white/10 rounded whitespace-nowrap">鲍鱼tv跳转</span>
                  <span className="px-2 py-1 bg-white/10 rounded whitespace-nowrap">鲍鱼tv跳转入口</span>
                  <span className="px-2 py-1 bg-white/10 rounded whitespace-nowrap">鲍鱼tv最新地址</span>
                  <span className="px-2 py-1 bg-white/10 rounded whitespace-nowrap">鲍鱼tv官网跳转</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}